import { AxiosInstance, AxiosResponse } from "axios";
import {
  ConsultProfileClientResponseDTO,
  GetClientInfoResponseDTO,
  ConsultProfileProposalsResponseDTO
} from "../entities/Client";

const resourcePrefix = "/Cliente";

export class ClientResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async consultProfile(
    strCliente: string
  ): Promise<AxiosResponse<ConsultProfileClientResponseDTO>> {
    return this.apiProvider.get(
      `${resourcePrefix}/ConsultarPerfil?strCliente=${strCliente}1`
    );
  }

  async getClientInfo(
    cpf: string
  ): Promise<AxiosResponse<GetClientInfoResponseDTO>> {
    return this.apiProvider.get(
      `${resourcePrefix}/ConsultarDadosCadastrais?strCliente=${cpf}1`
    );
  }

  async consultProfileProposals(
    strCliente: string
  ): Promise<AxiosResponse<ConsultProfileProposalsResponseDTO>> {
    return this.apiProvider.get(
      `${resourcePrefix}/ConsultarPerfilPropostas?strCliente=${strCliente}1`
    );
  }
}
